module.exports = __webpack_public_path__ + "static/media/9.13104eba.jpg";